import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import ContactForm from '../components/ContactForm'
import { OPENING_HOURS } from '../lib/cms'
import { imageUrl } from '../lib/images'

export default function KontaktPage({ settings }) {
  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'
  const email = settings?.email || 'steen@ekbiler.dk'
  const address = settings?.address || 'Mejerivej 12, 7250 Hejnsvig'
  const cvr = settings?.cvr || '28566956'
  const bookingUrl = settings?.booking_url || 'https://service.dinbilpartner.dk/book-tid'
  const mapsUrl =
    settings?.maps_url ||
    `https://www.google.com/maps/search/?api=1&query=EK+Biler+${encodeURIComponent(address)}`

  return (
    <>
      <MetaTags
        title="Kontakt | EK Biler v/Steen Svensson Ek"
        description="Hvis du har nogle spørgsmål eller kommentarer, er du mere end velkommen til at tage fat i os. Mejerivej 12, 7250 Hejnsvig. Tlf: 22 18 73 30."
        ogTitle="Kontakt | EK Biler v/Steen Svensson Ek"
        ogDescription="Hvis du har nogle spørgsmål eller kommentarer, er du mere end velkommen til at tage fat i os. Mejerivej 12, 7250 Hejnsvig. Tlf: 22 18 73 30."
        ogImage={imageUrl('img-7707-1-scaled.jpg', 'width=1200,quality=85,format=auto')}
      />

      {/* Hero Header */}
      <section className="bg-[#14171a] text-white py-14 sm:py-20 border-b border-[#262c33] relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={imageUrl('img-7707-1-scaled.jpg', 'width=1600,quality=80,format=auto')}
            alt="EK Biler værksted og bilsalg"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
              <Link to="/" className="hover:text-white">Forside</Link>
              <span>/</span>
              <span className="text-[#e20019]">Kontakt</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Kontakt os i dag
            </h1>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              Hvis du har nogle spørgsmål eller kommentarer, er du mere end velkommen til at tage
              fat i os. Vi står klar til at hjælpe dig på værkstedet eller med bilsalg.
            </p>
            <div className="pt-2 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white px-6 py-3 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-red-500 text-center"
              >
                <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                <span>Book tid online</span>
              </a>
              <a
                href={`tel:${phoneRaw}`}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#20252c] hover:bg-[#2b323c] border border-gray-700 text-white px-5 py-3 rounded-xl font-bold text-sm transition-colors whitespace-nowrap text-center"
              >
                <i className="fa-solid fa-phone text-[#e20019]" aria-hidden="true" />
                <span>Ring på {phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            {/* Left: Contact Info & Opening Hours from Scrape */}
            <div className="lg:col-span-6 space-y-8">
              {/* Company Details Card */}
              <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border border-gray-200 space-y-5">
                <div>
                  <div className="text-xs font-bold text-[#e20019] uppercase tracking-wider mb-1">
                    Virksomhedsoplysninger
                  </div>
                  <h2 className="text-2xl font-extrabold text-gray-900">
                    EK Biler v/Steen Svensson Ek
                  </h2>
                </div>

                <div className="space-y-4 text-sm text-gray-700">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-red-100 text-[#e20019] flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-location-dot" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">{address}</div>
                      <a
                        href={mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 text-[#e20019] hover:underline font-bold text-xs mt-1"
                      >
                        <span>Find vej på Google Maps</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-red-100 text-[#e20019] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Telefon</div>
                      <a
                        href={`tel:${phoneRaw}`}
                        className="font-bold text-gray-900 hover:text-[#e20019] transition-colors whitespace-nowrap text-base"
                      >
                        {phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-red-100 text-[#e20019] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">E-mail</div>
                      <a
                        href={`mailto:${email}`}
                        className="font-bold text-gray-900 hover:text-[#e20019] transition-colors whitespace-nowrap"
                      >
                        {email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-gray-200 text-gray-700 flex items-center justify-center shrink-0 text-xs font-bold">
                      CVR
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">CVR nr.</div>
                      <div className="font-bold text-gray-900">{cvr}</div>
                    </div>
                  </div>
                </div>

                <div className="pt-2">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white py-3.5 px-6 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
                  >
                    <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                    <span>Book tid til service eller reparation</span>
                  </a>
                </div>
              </div>

              {/* Opening hours from scrape verbatim */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 shadow-sm space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Åbningstider</h3>
                  <p className="text-xs text-gray-500 mt-1">Se vores faste åbningstider for salg, værksted og administration.</p>
                </div>

                {/* Værksted */}
                <div className="space-y-2">
                  <div className="flex items-center gap-2 font-bold text-sm text-gray-900 border-b border-gray-100 pb-1.5">
                    <i className="fa-solid fa-wrench text-[#e20019]" aria-hidden="true" />
                    <span>Værksted</span>
                  </div>
                  <div className="divide-y divide-gray-100 text-xs text-gray-700">
                    {OPENING_HOURS.vaerksted.map((row) => (
                      <div key={row.days} className="py-1.5 flex justify-between">
                        <span>{row.days}</span>
                        <span className="font-semibold">{row.hours}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Salg */}
                <div className="space-y-2">
                  <div className="flex items-center gap-2 font-bold text-sm text-gray-900 border-b border-gray-100 pb-1.5">
                    <i className="fa-solid fa-car text-[#e20019]" aria-hidden="true" />
                    <span>Salg</span>
                  </div>
                  <div className="divide-y divide-gray-100 text-xs text-gray-700">
                    {OPENING_HOURS.salg.map((row) => (
                      <div key={row.days} className="py-1.5 flex justify-between">
                        <span>{row.days}</span>
                        <span className="font-semibold">{row.hours}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Administration */}
                <div className="space-y-2">
                  <div className="flex items-center gap-2 font-bold text-sm text-gray-900 border-b border-gray-100 pb-1.5">
                    <i className="fa-solid fa-briefcase text-gray-500" aria-hidden="true" />
                    <span>Administration</span>
                  </div>
                  <div className="divide-y divide-gray-100 text-xs text-gray-700">
                    {OPENING_HOURS.administration.map((row) => (
                      <div key={row.days} className="py-1.5 flex justify-between">
                        <span>{row.days}</span>
                        <span className="font-semibold">{row.hours}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="lg:col-span-6 space-y-6">
              <ContactForm
                title="Skriv til os"
                subtitle="Har du spørgsmål eller ønsker et uforpligtende tilbud på din bil?"
                bookingUrl={bookingUrl}
              />

              {/* Map embed / Directions container */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200 space-y-3">
                <div className="flex items-center justify-between">
                  <div className="font-bold text-sm text-gray-900 flex items-center gap-2">
                    <i className="fa-solid fa-map-location-dot text-[#e20019]" aria-hidden="true" />
                    <span>Find vej til Mejerivej 12</span>
                  </div>
                  <a
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-[#e20019] font-bold hover:underline"
                  >
                    Åbn rutevejledning &rarr;
                  </a>
                </div>
                <div className="w-full h-64 bg-gray-200 rounded-xl overflow-hidden border border-gray-300 relative">
                  <iframe
                    title="EK Biler placering i Hejnsvig"
                    src="https://maps.google.com/maps?q=Mejerivej%2012,%207250%20Hejnsvig&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
